export default __webpack_public_path__ + "static/media/copied-icon.7d22a76b.svg";